@if (timezones$ | async; as timezones) {
  <mat-form-field floatLabel="auto" class="timezone">
    <mat-label>{{ 'Timezone' | translate }}</mat-label>
    <mat-select name="timezone" [placeholder]="'Timezone' | translate" [(value)]="selectedTimezone" (valueChange)="onValueChange($event)">
      @for (timezone of timezones; track timezone) {
        <mat-option [value]="timezone.value">{{ timezone.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}
